import './Logo.scss';
import logo from '../../assets/logo/default.png';

export default function Logo() {
    return (
        <a className="logo" href='https://neuro-research.ai/quantum/en'>
            <img src={logo} alt=''/>
        </a>
    )
}